import { Navigate } from "react-router-dom"
import { useAuth } from "@/hooks/useAuth"

/**
 * Route-Guard: leitet nicht-eingeloggte User auf /login um.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Pruefe Session...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
